import { SlaTimeFilter } from '@truepill/tpos-types'

// SLA filter logic to filter orders by the hours they were created
interface filterParams {
  slaFilter?: string
}

export const getSlaFilter = ({ slaFilter }: filterParams) => {
  if (!slaFilter) return {}

  if (slaFilter === SlaTimeFilter.NearlyOverdue) {
    // 12-24 hs
    const now = new Date()
    const minDate = new Date(now.getTime() - 24 * 60 * 60 * 1000)
    const maxDate = new Date(now.getTime() - 12 * 60 * 60 * 1000)
    return { createdAt: { $gte: minDate, $lt: maxDate } }
  }

  if (slaFilter === SlaTimeFilter.Overdue) {
    // 24+ hs
    const now = new Date()
    const maxDate = new Date(now.getTime() - 24 * 60 * 60 * 1000)
    return { createdAt: { $lt: maxDate } }
  }

  return {}
}
